(function () {
  const CUSTOMIZE_MOBILE_MQ = '(max-width: 749px)';
  const customizeMobileMQ = window.matchMedia(CUSTOMIZE_MOBILE_MQ);

  function getCart() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  function normalizeCartAddResponse(parsed) {
    if (!parsed || typeof parsed !== 'object') return;
    if (!parsed.key && parsed.items && parsed.items.length && parsed.items[0].key) {
      parsed.key = parsed.items[0].key;
    }
    if (parsed.id == null && parsed.items && parsed.items.length && parsed.items[0].variant_id != null) {
      parsed.id = parsed.items[0].variant_id;
    }
  }

  function cartSectionsPayload() {
    const cart = getCart();
    const base = { sections: [], sections_url: window.location.pathname };
    if (!cart || typeof cart.getSectionsToRender !== 'function') return base;
    base.sections = cart.getSectionsToRender().map((s) => s.id);
    return base;
  }

  function formatMoney(cents, currencyCode) {
    const n = (Number(cents) || 0) / 100;
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currencyCode || 'USD',
      }).format(n);
    } catch (e) {
      return n.toFixed(2);
    }
  }

  function isCustomizeMobile() {
    return customizeMobileMQ.matches;
  }

  function initModalCache(modal) {
    if (modal._customizeCache) return modal._customizeCache;

    const groups = modal.querySelectorAll('fieldset[data-group]');
    for (let g = 0; g < groups.length; g++) {
      const radios = groups[g].querySelectorAll('input[type="radio"]');
      for (let r = 0; r < radios.length; r++) {
        const input = radios[r];
        input._lineCents = Number(input.dataset.lineCents) || 0;
        if (input.dataset.productTitle) {
          input._productTitle = input.dataset.productTitle;
        }
      }
    }

    const drawer = modal.querySelector('[data-customize-product-drawer]');
    modal._customizeCache = {
      qty: modal.querySelector('.customize-modal__qty'),
      total: modal.querySelector('[data-customize-total]'),
      error: modal.querySelector('[data-customize-error]'),
      groups: groups,
      drawer: drawer
        ? {
            root: drawer,
            media: drawer.querySelector('[data-customize-product-drawer-media]'),
            title: drawer.querySelector('[data-customize-product-drawer-title]'),
            price: drawer.querySelector('[data-customize-product-drawer-price]'),
            desc: drawer.querySelector('[data-customize-product-drawer-description]'),
            panel: drawer.querySelector('.customize-modal__product-drawer-panel'),
            closeBtn: drawer.querySelector('[data-customize-product-drawer-close]'),
          }
        : null,
    };
    return modal._customizeCache;
  }

  function getModalCache(modal) {
    return modal._customizeCache || initModalCache(modal);
  }

  function getProductDrawer(modal) {
    const cache = getModalCache(modal);
    return cache.drawer ? cache.drawer.root : null;
  }

  function cloneChildNodes(sourceEl, targetEl) {
    if (!sourceEl || !targetEl) return;
    const clones = [];
    for (let i = 0; i < sourceEl.childNodes.length; i++) {
      clones.push(sourceEl.childNodes[i].cloneNode(true));
    }
    targetEl.replaceChildren.apply(targetEl, clones);
  }

  function closeCustomizeProductDrawer(modal, restoreFocus) {
    const cache = getModalCache(modal);
    const drawer = cache.drawer;
    if (!drawer || !drawer.root.classList.contains('is-open')) return;
    const trigger = drawer.root._openedBy || null;
    drawer.root.classList.remove('is-open');
    drawer.root.setAttribute('hidden', '');
    modal.classList.remove('product-customize-modal--drawer-open');
    if (drawer.media) drawer.media.replaceChildren();
    if (drawer.title) drawer.title.textContent = '';
    if (drawer.price) {
      drawer.price.replaceChildren();
      drawer.price.hidden = true;
    }
    if (drawer.desc) {
      drawer.desc.replaceChildren();
      drawer.desc.hidden = true;
    }
    if (typeof removeTrapFocus === 'function' && restoreFocus !== false) {
      removeTrapFocus(trigger);
    }
    drawer.root._openedBy = null;
  }

  function openCustomizeProductDrawer(modal, card, trigger) {
    const cache = getModalCache(modal);
    const drawer = cache.drawer;
    const source = card && card.querySelector('.customize-modal__card-detail-source');
    if (!drawer || !source) return;

    const imgSource = source.querySelector('[data-detail-image] img');
    const titleSource = source.querySelector('[data-detail-title]');
    const priceSource = source.querySelector('[data-detail-price]');
    const descSource = source.querySelector('[data-detail-description]');

    if (drawer.media) {
      if (imgSource) {
        const img = imgSource.cloneNode(true);
        img.removeAttribute('loading');
        drawer.media.replaceChildren(img);
      } else {
        drawer.media.replaceChildren();
      }
    }

    if (drawer.title) {
      drawer.title.textContent = titleSource ? titleSource.textContent.trim() : '';
    }

    if (drawer.price) {
      const hasPrice = priceSource && priceSource.childNodes.length > 0;
      if (hasPrice) {
        cloneChildNodes(priceSource, drawer.price);
        drawer.price.hidden = false;
      } else {
        drawer.price.replaceChildren();
        drawer.price.hidden = true;
      }
    }

    if (drawer.desc) {
      const hasDesc = descSource && descSource.childNodes.length > 0;
      if (hasDesc) {
        cloneChildNodes(descSource, drawer.desc);
        drawer.desc.hidden = false;
      } else {
        drawer.desc.replaceChildren();
        drawer.desc.hidden = true;
      }
    }

    drawer.root._openedBy = trigger;
    drawer.root.removeAttribute('hidden');
    modal.classList.add('product-customize-modal--drawer-open');

    window.requestAnimationFrame(function () {
      drawer.root.classList.add('is-open');
      if (typeof trapFocus === 'function' && drawer.panel) {
        trapFocus(drawer.panel, drawer.closeBtn || drawer.panel);
      }
    });
  }

  function getBaseCents(modal) {
    return parseInt(modal.dataset.baseVariantCents || '0', 10) || 0;
  }

  function isSkipInput(input) {
    if (!input) return true;
    if (input.dataset.skip === 'true') return true;
    const v = input.value;
    return v === '' || v === null;
  }

  function addonTotalCents(modal) {
    const cache = getModalCache(modal);
    let addon = 0;
    for (let i = 0; i < cache.groups.length; i++) {
      const checked = cache.groups[i].querySelector('input[type="radio"]:checked');
      if (!checked || checked.disabled || isSkipInput(checked)) continue;
      addon += checked._lineCents != null ? checked._lineCents : Number(checked.dataset.lineCents) || 0;
    }
    return addon;
  }

  function updateCustomizeTotal(modal) {
    const cache = getModalCache(modal);
    if (!cache.total) return;
    const currency = modal.dataset.currencyCode || 'USD';
    const addon = addonTotalCents(modal);
    const qty = Math.max(1, parseInt(cache.qty && cache.qty.value ? cache.qty.value : '1', 10) || 1);
    const total = (getBaseCents(modal) + addon) * qty;
    cache.total.textContent = formatMoney(total, currency);
  }

  function hideCustomizeError(modal) {
    const el = getModalCache(modal).error;
    if (!el) return;
    el.hidden = true;
    el.textContent = '';
  }

  function showCustomizeError(modal, msg) {
    const el = getModalCache(modal).error;
    if (!el) return;
    el.hidden = false;
    el.textContent = msg;
  }

  function collectCustomizeSelection(modal) {
    const cache = getModalCache(modal);
    const parts = [];
    const addonVariantIds = [];
    for (let i = 0; i < cache.groups.length; i++) {
      const group = cache.groups[i];
      const checked = group.querySelector('input[type="radio"]:checked');
      if (!checked || checked.disabled || isSkipInput(checked)) continue;
      const title = checked._productTitle || checked.dataset.productTitle || '';
      const gn = group.dataset.group || '';
      parts.push(`${gn}: ${title}`);
      addonVariantIds.push(parseInt(checked.value, 10));
    }
    return { summary: parts.join(' | '), addonVariantIds };
  }

  function validateB2BVariant(variantId) {
    const allowed = window.myProducts || [];
    const isOrderingOnly = window.isOrderingOnly;
    if (!isOrderingOnly) return true;
    const n = Number(variantId);
    return allowed.includes(n) || allowed.includes(String(variantId));
  }

  function parseCartAddResponse(response) {
    return response.json().catch(function () {
      return { _parseError: true };
    });
  }

  function isCartAddError(response, parsed) {
    if (parsed && parsed._parseError) return true;
    if (!response.ok) return true;
    if (parsed && (parsed.status === 422 || parsed.status === 404 || parsed.errors)) return true;
    return false;
  }

  function cartAddErrorMessage(parsed) {
    if (!parsed || parsed._parseError) return 'Unable to add to cart. Please try again.';
    return parsed.description || parsed.message || 'Unable to add to cart.';
  }

  function handleCustomizeAddToCart(modal, submitBtn) {
    hideCustomizeError(modal);
    const cache = getModalCache(modal);
    const selection = collectCustomizeSelection(modal);

    const formId = modal.dataset.productFormId;
    const form = formId ? document.getElementById(formId) : null;
    const mainInput = form && form.querySelector('input[name="id"]');
    if (!mainInput) {
      showCustomizeError(modal, 'Could not read product variant.');
      return;
    }
    const mainVid = parseInt(mainInput.value, 10);
    if (!mainVid) {
      showCustomizeError(modal, 'Could not read product variant.');
      return;
    }

    const qty = Math.max(1, parseInt(cache.qty && cache.qty.value ? cache.qty.value : '1', 10) || 1);

    const idsToCheck = [mainVid].concat(selection.addonVariantIds);
    for (let j = 0; j < idsToCheck.length; j++) {
      if (!validateB2BVariant(idsToCheck[j])) {
        alert('You do not have permission to add one or more of these items to the cart.');
        return;
      }
    }

    const parentTitle = modal.dataset.productTitle || '';
    const mainProperties = { _dm_cart_parent: 'true' };
    if (selection.summary) {
      mainProperties.Configuration = selection.summary;
    }
    const items = [];
    items.push({
      id: mainVid,
      quantity: qty,
      properties: mainProperties,
    });
    for (let k = 0; k < selection.addonVariantIds.length; k++) {
      const vid = selection.addonVariantIds[k];
      if (vid === mainVid) continue;
      items.push({
        id: vid,
        quantity: qty,
        properties: {
          'Add-on for': parentTitle,
          _dm_cart_part: 'true',
        },
      });
    }

    const sec = cartSectionsPayload();
    const bodyObj = {
      items,
      sections: sec.sections,
      sections_url: sec.sections_url,
    };

    const spinner = submitBtn.querySelector('.loading__spinner');
    submitBtn.setAttribute('aria-disabled', 'true');
    submitBtn.classList.add('loading');
    if (spinner) spinner.classList.remove('hidden');

    const url = window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add.js';

    fetch(url, {
      ...fetchConfig(),
      body: JSON.stringify(bodyObj),
    })
      .then(function (response) {
        return parseCartAddResponse(response).then(function (parsed) {
          if (isCartAddError(response, parsed)) {
            showCustomizeError(modal, cartAddErrorMessage(parsed));
            return null;
          }
          return parsed;
        });
      })
      .then(function (parsed) {
        if (!parsed) return;

        const cart = getCart();
        if (!cart) {
          window.location.href = window.routes?.cart_url || '/cart';
          return;
        }

        normalizeCartAddResponse(parsed);

        try {
          if (typeof cart.renderContents === 'function' && parsed.sections) {
            cart.renderContents(parsed);
          }
        } catch (err) {
          console.error('[product-customize-modal] cart renderContents failed', err);
        }

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-customize-modal',
            cartData: parsed,
          });
        }
        document.dispatchEvent(new Event('cart:updated'));

        if (typeof window.trackEvent === 'function') {
          window.trackEvent('Add To Cart', 'WEBSITE: Customize bundle added', {
            variant_id: mainVid,
            quantity: qty,
            source: 'customize-modal',
          });
        }

        if (typeof modal.hide === 'function') modal.hide();
      })
      .catch(function () {
        showCustomizeError(modal, 'Unable to add to cart. Please try again.');
      })
      .finally(function () {
        submitBtn.classList.remove('loading');
        submitBtn.removeAttribute('aria-disabled');
        if (spinner) spinner.classList.add('hidden');
      });
  }

  document.addEventListener('click', function (e) {
    const customizeBtn = e.target.closest('.product-form__customize-now');
    if (customizeBtn && !customizeBtn.disabled) {
      const modalId = customizeBtn.getAttribute('data-customize-modal-id');
      if (modalId) {
        const modal = document.getElementById(modalId);
        if (modal && typeof modal.show === 'function') {
          e.preventDefault();
          closeCustomizeProductDrawer(modal, false);
          initModalCache(modal);
          modal.show(customizeBtn);
          window.requestAnimationFrame(function () {
            updateCustomizeTotal(modal);
          });
          return;
        }
      }
    }

    const viewBtn = e.target.closest('[data-customize-view-product]');
    if (viewBtn) {
      if (!isCustomizeMobile()) return;
      const card = viewBtn.closest('.customize-modal__card');
      const modal = viewBtn.closest('modal-dialog.product-customize-modal');
      if (!card || !modal || card.classList.contains('customize-modal__card--disabled')) return;
      e.preventDefault();
      e.stopPropagation();
      openCustomizeProductDrawer(modal, card, viewBtn);
      return;
    }

    const drawerClose = e.target.closest('[data-customize-product-drawer-close]');
    if (drawerClose) {
      const drawer = drawerClose.closest('[data-customize-product-drawer]');
      const modal = drawerClose.closest('modal-dialog.product-customize-modal');
      if (!drawer || !modal || !drawer.classList.contains('is-open')) return;
      e.preventDefault();
      e.stopPropagation();
      closeCustomizeProductDrawer(modal);
      return;
    }

    const submit = e.target.closest('[data-customize-submit]');
    if (submit) {
      const modal = submit.closest('modal-dialog.product-customize-modal');
      if (!modal) return;
      e.preventDefault();
      handleCustomizeAddToCart(modal, submit);
      return;
    }
  });

  document.addEventListener(
    'keyup',
    function (e) {
      if (e.code.toUpperCase() !== 'ESCAPE') return;
      const openDrawer = document.querySelector(
        'modal-dialog.product-customize-modal[open] [data-customize-product-drawer].is-open'
      );
      if (!openDrawer) return;
      const modal = openDrawer.closest('modal-dialog.product-customize-modal');
      if (!modal) return;
      e.stopPropagation();
      e.stopImmediatePropagation();
      closeCustomizeProductDrawer(modal);
    },
    true
  );

  document.body.addEventListener('modalClosed', function () {
    document.querySelectorAll('modal-dialog.product-customize-modal').forEach(function (modal) {
      closeCustomizeProductDrawer(modal, false);
    });
  });

  document.addEventListener(
    'click',
    function (e) {
      const media = e.target.closest('.customize-modal__card-media');
      if (!media) return;
      const card = media.closest('.customize-modal__card');
      if (!card || card.classList.contains('customize-modal__card--disabled')) return;
      const inp = card.querySelector('input[type="radio"]');
      if (!inp || inp.disabled) return;
      if (!inp.checked) {
        inp.checked = true;
        inp.dispatchEvent(new Event('change', { bubbles: true }));
      }
    },
    true
  );

  document.addEventListener('change', function (e) {
    const modal = e.target.closest('modal-dialog.product-customize-modal');
    if (!modal) return;
    if (e.target.matches('fieldset[data-group] input[type="radio"]')) {
      hideCustomizeError(modal);
      updateCustomizeTotal(modal);
    }
  });

  document.addEventListener('input', function (e) {
    if (!e.target.classList.contains('customize-modal__qty')) return;
    const modal = e.target.closest('modal-dialog.product-customize-modal');
    if (modal) updateCustomizeTotal(modal);
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (payload) {
      const d = payload && payload.data;
      if (!d || !d.variant || d.variant.price == null) return;
      const sid = String(d.sectionId);
      document.querySelectorAll('modal-dialog.product-customize-modal').forEach(function (modal) {
        if (String(modal.dataset.sectionId) !== sid) return;
        modal.dataset.baseVariantCents = String(d.variant.price);
        if (modal.hasAttribute('open')) updateCustomizeTotal(modal);
      });
    });
  }
})();
